import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { PrismIcon } from '@mylighthouse/prism-ember';
import { eq } from 'ember-truth-helpers';

import styles from './section-header-breadcrumbs.module.css';

export interface SectionHeaderBreadcrumb {
  id: string | null;
  isClickable: boolean;
  isTopLevel?: boolean;
  label: string;
}

interface HotelBenchmarkInsightSectionsSectionHeaderBreadcrumbsSignature {
  Args: {
    breadcrumbs: SectionHeaderBreadcrumb[];
    onClickBreadcrumb: (breadcrumbId: string | null) => void;
    title: string;
  };
}

const HotelBenchmarkInsightSectionsSectionHeaderBreadcrumbs = <template>
  <div class="flex items-center gap-100">
    {{#if @breadcrumbs.length}}
      <button
        class="{{styles.back-button}}
          {{styles.button--unstyled}}
          flex flex-row items-center"
        type="button"
        {{on "click" (fn @onClickBreadcrumb null)}}
      >
        <PrismIcon @color="inherit" @name="arrow-left" />
      </button>
    {{/if}}

    <p class="text-400--bold">
      {{#if @breadcrumbs.length}}
        {{#each @breadcrumbs as |breadcrumb index|}}
          {{#unless (eq index 0)}}
            <span class="mx-100">/</span>
          {{/unless}}

          {{#if breadcrumb.isClickable}}
            <span
              class="text-400--bold cursor-pointer
                {{unless breadcrumb.isTopLevel 'text-neutral-subdued'}}
                hover:underline"
              data-test-id="section-header-breadcrumb"
              role="button"
              {{on "click" (fn @onClickBreadcrumb breadcrumb.id)}}
            >
              {{breadcrumb.label}}
            </span>
          {{else}}
            <span
              class="text-400--bold text-neutral-subdued"
              data-test-id="section-header-breadcrumb"
            >
              {{breadcrumb.label}}
            </span>
          {{/if}}
        {{/each}}
      {{else}}
        <span class="text-400--bold">
          {{@title}}
        </span>
      {{/if}}
    </p>
  </div>
</template> satisfies TOC<HotelBenchmarkInsightSectionsSectionHeaderBreadcrumbsSignature>;

export default HotelBenchmarkInsightSectionsSectionHeaderBreadcrumbs;
